import React from 'react'
import { Table } from 'semantic-ui-react';


const Configuration = ({ configuration, profile }) => {

    const getCheckedIcon = (isChecked, desc) => {
        if (isChecked) {
            return <div><i aria-hidden="true" className="check icon"></i> {desc}</div>;
        }
        else {
            return <div><i aria-hidden="true" className="x icon"></i> {desc}</div>;
        }
    }

    const getAntennaTypeString = (ant_type) => {
        switch (ant_type) {
            case 0:
                return 'GSM';
            case 1:
                return 'UMTS';
            case 2:
                return 'LTE';
            default:
                return 'Not Defined';
        }
    }

    const getAntennaTypeRows = () => {
        if (configuration.ant_type === 1) {
            return (
                <Table.Row key='allocated_cpich' >
                    <Table.Cell>
                        Allocated CPICH (dBm)
                        </Table.Cell>
                    <Table.Cell>
                        {configuration.allocated_cpich}
                    </Table.Cell>
                </Table.Row>
            )
        }
        if (configuration.ant_type === 2) {
            const channelBandwidths = [
                [0, '1.4'],
                [1, '3'],
                [2, '5'],
                [3, '10'],
                [4, '15'],
                [5, '20'],
            ];
            return (
                <Table.Row key='channel_bandwidth' >
                    <Table.Cell>
                        Channel Bandwidth (MHz)
                        </Table.Cell>
                    <Table.Cell>
                        {channelBandwidths[configuration.channel_bandwidth][1]}
                    </Table.Cell>
                </Table.Row>
            )
        }
    }

    if (!configuration) {
        return <div>Loading...</div>;
    }
    return (
        <div>
            <Table celled inverted selectable size='small'
            >
                <Table.Body>
                    <Table.Row key='ant_type' >
                        <Table.Cell>
                            Antenna Type
                        </Table.Cell>
                        <Table.Cell>
                            {getAntennaTypeString(configuration.ant_type)}
                        </Table.Cell>
                    </Table.Row>
                    {getAntennaTypeRows()}
                    <Table.Row key='units_length' >
                        <Table.Cell>
                            Units for length
                        </Table.Cell>
                        <Table.Cell>
                            {profile.units_length_string}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row key='units_power' >
                        <Table.Cell>
                            Units for power
                        </Table.Cell>
                        <Table.Cell>
                            {profile.units_power_string}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row key='ant_gain' >
                        <Table.Cell>
                            Antenna gain (dBi)
                        </Table.Cell>
                        <Table.Cell>
                            {configuration.ant_gain}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row key='bts_ht' >
                        <Table.Cell>
                            Base station antenna height ({profile.units_length_string})
                        </Table.Cell>
                        <Table.Cell>
                            {configuration.bts_ht_local}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row key='fr' >
                        <Table.Cell>
                            Frequency in MHz (20 MHz to 20 GHz)
                        </Table.Cell>
                        <Table.Cell>
                            {configuration.fr}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row key='txpwr' >
                        <Table.Cell>
                            Transmit power ({profile.units_power_string})
                        </Table.Cell>
                        <Table.Cell>
                            {configuration.txpwr_local}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row key='max_range' >
                        <Table.Cell>
                            Max coverage range (km)
                        </Table.Cell>
                        <Table.Cell>
                            {configuration.max_range}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row key='buffer_distance' >
                        <Table.Cell>
                            Buffer distance (km)
                        </Table.Cell>
                        <Table.Cell>
                            {configuration.buffer_distance}
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>

            {getCheckedIcon(configuration.bts_ht_override, 'override sites height in collection')}
            {getCheckedIcon(configuration.txpwr_override, 'override sites transmit power in collection')}
            {getCheckedIcon(configuration.is_sector, ' create new antennas as sectored')}

        </div>
    )
}

export default Configuration;
